export default __webpack_public_path__ + "static/media/service-logo-panoramica.ee809bc2.png";